export default __webpack_public_path__ + "6f999db900090946e6662bf9a5fb622a.png";